import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import ActivityPanel from "./ActivityPanel";
import { placementsOf } from "./segments";

// What the drawer holds for one impact row: what is being DONE about it — its
// activities — under a header naming the impact and where it sits.
export default function ImpactDetailPanel({
    projectId,
    impact,
    // The project's segments, to name where this impact sits.
    segments = [],
    onActivitiesChanged,
    // False for a project viewer: the activities are listed, not changed.
    canEdit = true,
}) {
    const placements = placementsOf(impact, segments);

    return (
        <Box>
            <Paper
                variant="outlined"
                sx={{ p: 1.5, borderRadius: 2, mb: 2, backgroundColor: "rgba(0,67,142,0.04)" }}
            >
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {impact?.what_is_changing}
                </Typography>
                {placements.length > 0 && (
                    <Typography variant="caption" sx={{ color: "text.secondary" }}>
                        {placements.map(({ segment, choice }) => `${segment.title}: ${choice.label}`).join(" · ")}
                    </Typography>
                )}
            </Paper>

            <ActivityPanel
                projectId={projectId}
                impact={impact}
                onChanged={onActivitiesChanged}
                canEdit={canEdit}
            />
        </Box>
    );
}
